import React, { useState, useContext, useEffect } from 'react';
import Portal from 'src/pages/InsigthFactory/Portal';
import { useHistory } from 'react-router-dom';
import * as paths from 'src/routes/paths';
import pagination from 'src/utils/pagination';
import { getHistories, getSugerence, getUnitHistory } from 'src/services/insightPortalService';
import { swalMessages, permitsList } from 'src/constants';
import { getUnidades } from 'src/services/insightService';
import { getGDCClusters } from '@auteco/services/gdcServices';
import swal from 'sweetalert';
import { Context } from '../../context/Contex';


const PortalContainer = () => {
  const [postPerPage] = useState(5);
  const [input, setInput] = useState('');
  const [units, setUnits] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [sugerence, setSugerence] = useState([]);
  const [histories, setHistories] = useState([]);
  const [filterState, setFilterState] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [sugerenceCard, setSugerenceCard] = useState([]);
  const [clusters, setClusters] = useState([])
  const [selectedClusters, setSelectedClusters] = useState([])
  const [filter, setFilter] = useState(false)

  const history = useHistory();
  const { permisos } = useContext(Context);
  const permitValue = permisos[permitsList.FABRICA_INSIGHTS];

  const onChangePage = (e, page) => {
    setCurrentPage(page);
  };

  const { currentPosts } = pagination(filtered, currentPage, postPerPage);
  const { totalPages } = pagination(filtered, currentPage, postPerPage);

  const handleClickUsers = () => {
    history.push(paths.INSIGHT_USERS);
  };

  const handleClickTest = () => {
    history.push(paths.INSIGHT_TEST_ACCEPT);
  };

  const handleClickEntries = () => {
    history.push(paths.INSIGHT_NEW_ENTRIES);
  };

  const handleClickChanges = () => {
    history.push(paths.INSIGHT_CHANGES);
  };

  const onSearchInput = async () => {
    const { success, data, error } = await getHistories(input);
    if (success) {
      setErrorMsg('');
      setFilterState('');
      setHistories(data);
      setFiltered(data);
      if (input !== '') {
        setFilter(true)
      } else {
        setFilter(false)
      }
    } else {
      setErrorMsg(error);
      setHistories([]);
      setFiltered([]);
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setSelectedClusters([])
    onSearchInput()
  };

  const onChangeInput = (value) => {
    setInput(value);
  };

  const fetchUnidades = async () => {
    const { success, data } = await getUnidades();
    if (success) {
      setUnits(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const fetchSugerence = async () => {
    const { success, data } = await getSugerence();
    if (success) {
      const onlyTitles = data.map((item) => item.titulo);
      setSugerence(onlyTitles);
      setSugerenceCard(data);
    } else {
      swal(swalMessages.GENERAL_ERROR);
    }
  };

  const onSearchUnity = async (index) => {
    setInput('')
    setFilter(true)
    const idUnit = units[index].id;
    const { success, data, error } = await getUnitHistory(idUnit);
    if (success) {
      setErrorMsg('');
      setHistories(data);
      setFiltered(data);
      setFilterState(index);
    } else {
      setErrorMsg(error);
      setHistories([]);
      setFiltered([]);
    }
  };

  const getClusters = async () => {
    const response = await getGDCClusters({ partner: 0 })
    if (response.cluster) {
      const filteredClusters = response.cluster.filter(item => item.nombre !== 'Ojo este no debe salir')
      setClusters(filteredClusters)
    }
  }

  const onChangeFilter = (event) => {
    const { value } = event.target;
    if (value !== '') {
      onSearchUnity(value);
    } else {
      setFiltered([]);
      setHistories([]);
    }
    setFilterState(value);
    setSelectedClusters([]);
  };

  const onSelectClusters = ({ value }) => {
    setFilterState('')
    setErrorMsg('');
    const formated = Array.isArray(value) ? value : [value]
    const ids = formated.map(val => val.id)
    const cards = sugerenceCard
    const currentCards = cards.filter(card => ids.includes(card.cluster_id))
    if (formated.length > 0) {
      if (formated[formated.length - 1].nombre === 'Todos') {
        setSelectedClusters([{ nombre: 'Todos', id: 'all' }])
        setHistories(cards)
        setFiltered(cards)
      } else {
        const newClusters = clusters.filter(cluster => ids.includes(cluster.id))
        setSelectedClusters(newClusters)
        setHistories(currentCards)
        setFiltered(currentCards)
      }
      setFilter(true)
      setInput('')
    } else if (formated.length === 0 && input === '') {
      setFilter(false)
      setSelectedClusters([])
      setHistories([])
      setFiltered([])
    } else if (formated.length === 0 && input !== '') {
      setSelectedClusters([])
      onSearchInput()
    }
  }

  const onSelectOneCluster = ({ event, value }) => {
    event.stopPropagation()
    setFilterState('')
    setErrorMsg('');
    const formated = [value]
    const currentCards = sugerenceCard.filter(card => card.cluster_id === value.id)
    if (formated.length > 0) {
      if (value.nombre === 'Todos') {
        setSelectedClusters([{ nombre: 'Todos', id: 'all' }])
        setHistories(sugerenceCard)
        setFiltered(sugerenceCard)
      } else {
        setSelectedClusters(formated)
        setHistories(currentCards)
        setFiltered(currentCards)
      }
      setFilter(true)
      setInput('')
    } else if (formated.length === 0 && input === '') {
      setFilter(false)
      setSelectedClusters([])
      setHistories([])
      setFiltered([])
    } else if (formated.length === 0 && input !== '') {
      onSearchInput()
    }
  }

  const onClickReturn = () => {
    setFilter(false)
    setSelectedClusters([])
    setHistories([])
    setFiltered([])
    setInput('')
    setFilterState('')
  };

  useEffect(() => {
    fetchUnidades();
    fetchSugerence();
    getClusters()
  }, []);
  return (
    <Portal
      input={input}
      units={units}
      posts={histories}
      onSubmit={onSubmit}
      errorMsg={errorMsg}
      sugerence={sugerence}
      totalPages={totalPages}
      clusters={clusters}
      filterState={filterState}
      selectedClusters={selectedClusters}
      histories={currentPosts}
      permitValue={permitValue}
      filter={filter}
      onChangePage={onChangePage}
      sugerenceCard={sugerenceCard}
      onSearchUnity={onSearchUnity}
      onChangeInput={onChangeInput}
      onChangeFilter={onChangeFilter}
      handleClickTest={handleClickTest}
      handleClickUsers={handleClickUsers}
      handleClickEntries={handleClickEntries}
      handleClickChanges={handleClickChanges}
      onSelectClusters={onSelectClusters}
      onSelectOneCluster={onSelectOneCluster}
      onClickReturn={onClickReturn}
    />
  );
};

export default PortalContainer;
